import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, FileText, Image as ImageIcon, MessageCircle, Video, Zap, ShieldCheck } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: FileText,
    title: 'Guía paso a paso en PDF',
    desc: 'El mapa exacto para crear tu producto desde cero.'
  }, {
    icon: ImageIcon,
    title: 'Pack de portadas que venden',
    desc: 'Plantillas premium para que tu producto luzca profesional.'
  }, {
    icon: MessageCircle,
    title: 'Scripts para cerrar por WhatsApp',
    desc: 'Textos probados para convertir curiosos en clientes.'
  }, {
    icon: Video,
    title: 'Plataformas para videos faceless',
    desc: 'Dónde encontrar el mejor contenido sin mostrar tu cara.'
  }, {
    icon: Zap,
    title: 'Acceso inmediato',
    desc: 'Descarga todo el material al instante tras tu compra.'
  }, {
    icon: ShieldCheck,
    title: 'Garantía 7 días',
    desc: 'Prueba el sistema sin riesgo. Si no te gusta, te devolvemos tu dinero.'
  }];
  return <section className="bg-dark py-24 px-4 relative overflow-hidden" data-id="element-282">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-283">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/20 rounded-full blur-3xl" data-id="element-284"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-cta/20 rounded-full blur-3xl" data-id="element-285"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-287">
          <span className="text-primary font-bold uppercase tracking-wider text-sm mb-2 block" data-id="element-288">
            Todo lo que necesitas
          </span>
          <h2 className="text-3xl md:text-5xl text-white font-display font-extrabold tracking-headline" data-id="element-289">
            Qué Recibes Hoy
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-290">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-[20px] p-6 hover:bg-white/10 transition-colors" data-id="element-291">
              <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center mb-4" data-id="element-292">
                <item.icon className="w-6 h-6 text-primary" data-id="element-293" />
              </div>
              <h3 className="text-xl text-white font-display font-bold mb-2 flex items-center gap-2" data-id="element-294">
                <CheckCircle2 className="w-5 h-5 text-primary" data-id="element-295" />
                {item.title}
              </h3>
              <p className="text-slate-300 leading-relaxed text-sm" data-id="element-296">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}